import styled from 'styled-components';

export type NavPlacement = 'left' | 'right';

export const DropdownNavigationWrapper = styled.div<{ placement: NavPlacement }>`
   flex-wrap: nowrap;
   height: 100%;
   display: none;

   ${({ theme, placement }) =>
     placement === 'left'
       ? `margin-right: auto; margin-left: ${theme.spacing['32']};`
       : `margin-right: ${theme.spacing['16']};`}

   a {
    color: inherit;
   }

   ${({ theme }) => theme.mediaBreakpointUp.md} {
    display: flex;
   }
`;
